<template>
    <el-dialog title="详情" :model-value="modelValue" @open="onOpen" @close="closed" :close-on-click-modal="false">
        <el-table :data="table_data" border v-loading="tableLoading">
            <el-table-column label="户名" min-width="100" prop="name"></el-table-column>
            <el-table-column label="IMEI" min-width="100" prop="IMEI"></el-table-column>
            <el-table-column label="状态" min-width="100" prop="status"></el-table-column>
            <el-table-column label="地址" min-width="100" prop="url"></el-table-column>
            <el-table-column label="推送结果" min-width="100" prop="account"></el-table-column>
        </el-table>
        <el-pagination
            :current-page="page_params.page"
            :page-size="page_params.page_size"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            class="elPagination"
        ></el-pagination>
    </el-dialog>
</template>
<script setup>
import { defineEmits, defineProps, reactive, ref } from 'vue'

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true
    },
    modelId: {
        type: String,
        required: false
    }
})
const emits = defineEmits(['update:modelValue', 'updateForm'])

// 弹窗打开
function onOpen() {
    getTableData()
}

const table_data = ref([])
const tableLoading = ref(false)
const total = ref(0)

// 获取列表数据
async function getTableData() {
    // tableLoading.value = true
    const params = { ...page_params }
    /*getDeviceList(params).then((data) => {
        table_data.value = data.lists
    })*/
    table_data.value = [
        {
            device_type: 1,
            push_type: 1
        }
    ]
    // total.value = data.total
    tableLoading.value = false
}

// 分页相关
const page_params = reactive({
    page: 1,
    page_size: 10
})
const handleSizeChange = (currentSize) => {
    page_params.page_size = currentSize
    getTableData()
}
const handleCurrentChange = (currentPage) => {
    page_params.page = currentPage
    getTableData()
}

// 关闭
const closed = () => {
    emits('update:modelValue', false)
    table_data.value = []
}
</script>

<style lang="scss" scoped>
.elPagination {
    margin-top: 20px;
    float: none !important;
}
</style>
